import { ButtonVariants } from '../../constants'

import { useEffect, useState } from 'react'

import classNames from 'classnames'
import RoundedButton from 'components/Atoms/Buttons/RoundedButton/RoundedButton'
import CicloBonoFrame from 'components/Atoms/CicloBonoFrame'
import CicloBonoFrame2 from 'components/Atoms/CicloBonoFrame2'
import RichText from 'components/Atoms/RichText'
import FaqsCicloBono from 'components/Molecules/FaqsCicloBono'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function CicloBono() {
  const [t, i18n] = useTranslation('ciclo-bono')
  const navigate = useNavigate()
  const [isQrModalOpen, setIsQrModalOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 767px)')
    const update = () => setIsMobile(mql.matches)
    update()

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', update)
      return () => mql.removeEventListener('change', update)
    }

    mql.addListener(update)
    return () => mql.removeListener(update)
  }, [])

  useEffect(() => {
    if (!isQrModalOpen) return

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsQrModalOpen(false)
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isQrModalOpen])

  const handleDownloadClick = () => {
    if (isMobile) {
      navigate('/qr')
      return
    }

    setIsQrModalOpen(true)
  }
  const bodyClassname = classNames(
    'container',
    'mx-auto',
    'space-y-10',
    'text-center',
    'md:text-left',
    'md:space-y-20',
    'max-w-screen-xl',
    'px-4',
    'md:px-28',
    'relative',
    'z-10',
  )
  const titleClassName = classNames(
    'relative',
    'z-20',
    'w-full',
    'text-center',
    'sm:text-start',
    'font-bold',
    'text-black',
    'text-3xl',
    'sm:text-4xl',
  )
  const subtitleClassName = classNames(
    'relative',
    'z-20',
    'w-full',
    'text-md',
    'sm:text-xl',
    'font-semibold',
    'text-grey-800',
  )
  const titleClassName2 = classNames(
    'relative',
    'text-center',
    'sm:text-left',
    'z-20',
    'w-full',
    'text-2xl',
    'sm:text-4xl',
    'font-bold',
  )
  const subtitleClassName2 = classNames(
    'relative',
    'z-20',
    'w-full',
    'text-md',
    'sm:text-xl',
    'font-semibold',
  )
  return (
    <div className="mb-24">
      {isQrModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center"
          style={{ zIndex: 1000 }}
          role="dialog"
          aria-modal="true"
          aria-label="QR"
        >
          <button
            type="button"
            className="absolute inset-0 bg-offBlack/60"
            onClick={() => setIsQrModalOpen(false)}
            aria-label="Cerrar"
          />
          <div
            className="relative w-[92vw] max-w-[400px] max-h-[92vh] overflow-auto rounded-3xl"
            style={{ zIndex: 1001 }}
          >
            <button
              type="button"
              onClick={() => setIsQrModalOpen(false)}
              aria-label="Cerrar"
              className="absolute top-3 right-3 w-9 h-9 rounded-3xl bg-white text-gray-800 shadow-md flex items-center justify-center"
            >
              <span aria-hidden="true">×</span>
            </button>
            <div className="bg-white p-6 space-y-6">
              <img
                src="/QR_download.jpg"
                alt="QR"
                className="w-full h-auto rounded-2xl"
              />
              <div className="flex flex-row space-x-2 items-center justify-center">
                <a
                  href="https://play.google.com/store/apps/details?id=es.inmovens.ciclogreen&hl=es&pli=1&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    alt="Badge Google Play"
                    src={`https://play.google.com/intl/en_us/badges/static/images/badges/${i18n.language}_badge_web_generic.png`}
                    className={i18n.language === 'en' ? 'h-[60px]' : 'h-[50px]'}
                  />
                </a>
                <a
                  href="https://apps.apple.com/us/app/ciclogreen-sustanaiblemobility/id1326776999?itsct=apps_box_badge&amp;itscg=30200"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-block',
                    overflow: 'hidden',
                    borderRadius: '13px',
                  }}
                  className="h-[40px]"
                >
                  <img
                    src={`https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/${i18n.language}-${i18n.language}?releaseDate=1515715200`}
                    alt="App Store"
                    style={{
                      borderRadius: '13px',
                    }}
                    className="h-[40px]"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={bodyClassname}>
        <div className="relative z-10 flex flex-col-reverse lg:flex-row items-center md:space-x-24">
          <div className="basis-full sm:basis-1/2 p-4 sm:p-0 space-y-4 sm:mt-0">
            <h1 className={titleClassName}>
              <RichText boldClassName="text-blue-800" content={t('title')} />
            </h1>
            <RichText
              className={subtitleClassName}
              boldClassName="text-blue-800"
              content={t('subtitle')}
            />
            <div className="flex flex-col sm:flex-row sm:items-stretch md:space-x-4 max-sm:space-y-4 sm:space-y-0">
              <RoundedButton
                variant={ButtonVariants.PRIMARY}
                className="relative justify-start z-10 max-sm:mt-10 sm:h-full"
                onClick={handleDownloadClick}
              >
                {t('btn.download')}
              </RoundedButton>
              {/* <RoundedButton
                variant={ButtonVariants.SECONDARY}
                className="relative justify-start z-10 mt-10 sm:h-full"
                onClick={() => {
                  navigate('/calculator')
                }}
              >
                {t('btn.calculator')}
              </RoundedButton> */}
            </div>
          </div>
          <div className="basis-full sm:basis-1/2 flex justify-center items-center">
            <video
              className="w-full  mx-auto rounded-xl shadow-lg"
              poster={`https://videos.ciclogreen.com/thumbnail_ciclobono2.jpg`}
              controls
              preload="metadata"
            >
              <source
                src={'https://videos.ciclogreen.com/CicloBono.mp4'}
                type="video/mp4"
              />
            </video>
          </div>
        </div>

        <CicloBonoFrame
          className="mt-10 items-center bg-gradient-to-t sm:bg-gradient-to-br from-green-800 via-blue-800 to-black"
          typeCard
          img={`${process.env.REACT_APP_URL_S3}/images/ciclobono/CicloBonoWorks_new.png`}
          id="how_it_works"
        >
          <div className="flex flex-col space-y-6 md:w-1/2 text-white text-start items-center md:items-start">
            <div className="flex flex-col items-start space-y-6">
              <h3 className={titleClassName2}>{t('howItWorks.title')}</h3>
              <RichText
                className="text-center sm:text-left"
                content={t('howItWorks.text1')}
              />
              <RichText
                className="text-center sm:text-left"
                content={t('howItWorks.text2')}
              />
            </div>
          </div>
        </CicloBonoFrame>

        <FaqsCicloBono />
      </div>
      <CicloBonoFrame2
        className="mt-10 items-center bg-gradient-to-r from-blue-800 to-black z-50"
        img={`${process.env.REACT_APP_URL_S3}/images/ciclobono/InviteFriends.png`}
      >
        <div className="flex flex-col space-y-6 md:w-1/3 2xl:w-1/4 text-white text-center md:text-start items-center md:items-start">
          <h3 className={subtitleClassName2}>{t('secondFrame.title')}</h3>
          <span>{t('secondFrame.text')}</span>
        </div>
      </CicloBonoFrame2>
    </div>
  )
}
